import React from "react";
import styled from "styled-components";
import { SiteData } from "react-static";

const Container = styled.div`
  width: 100%;
  font-size: 1em;
  font-family: Raleway, sans-serif;
  font-weight: 600;
  padding: 1em;
  color: white;
  box-sizing: border-box;
  background: linear-gradient(90deg, #cebfff, #9f7fff);
  text-align: center;
  bottom: 0;
  position: absolute;
`;

const Link = styled.a`
  font-size: 1em;
  font-family: Raleway, sans-serif;
  font-weight: 600;
  color: white;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Delimeter = styled.span`
  padding-left: 1em;
  padding-right: 1em;
`;

export default () => (
  <SiteData
    render={({ cms }) => (
      <Container>
        {cms["site-title"]} © {new Date().getFullYear()}
        <Delimeter>|</Delimeter>
        <Link href="/impressum">Impressum & Datenschutz</Link>
      </Container>
    )}
  />
);



// WEBPACK FOOTER //
// /opt/build/repo/src/segments/FooterSegment.js